import React, {useState} from 'react';
import './About.css'


export default function About() {


    const [progress] = useState({
        html: 90,
        css: 80,
        javascript: 60,
        react: 60,
        cms: 80,
        seo: 85,
        node: 55,
        udesign: 60,
        gdesign: 70

    })


    const bar = {
        width: '100%', 
        backgroundColor:'white', 
        borderRadius: '10px',
        margin: '2em 0'
    }


    return (
        <div className='about'>
       
        <div className='about-section' id="about">
        
        <div className='about-left'>
            <div className='education'>
                <div>
                    <h3>Education</h3>
                    <ul>
                        <li>Msc. Computer Science | Felician University</li>
                        <li>B.B.A (Strategic Marketing) | University of Namibia</li>
                        <li>Associate of Science (Web Development) | Raritan Valley Community College</li>
                    </ul>
                </div>

            </div>

            <div className="pro">
            <h3>Proficiencies</h3>
                    <ul>
                        <li>Git Version Control</li>
                        <li>Responsive Design</li>
                        <li>Accessibility</li>
                        <li>Testing and debugging</li>
                        <li>Performance Optimization</li>
                        <li>Collaborative Communication</li>
                        <li>Web Analytics (Google, Adobe & Bitly)</li>
                    </ul>

            </div>
         </div>


         <div className='about-right'>
            <div className='skills'>
            <h3>Skills</h3>
            <div style={bar}>
                <div className="progressBarStyle" style={{width: `${progress.html}%`}}>HTML {progress.html}%</div>
            </div>
            <div style={bar}>
                <div className="progressBarStyle" style={{width: `${progress.css}%`}}>CSS {progress.css}%</div>
            </div>
            <div style={bar}>
                <div className="progressBarStyle" style={{width: `${progress.javascript}%`}}>JavaScript {progress.javascript}%</div>
            </div>
            <div style={bar}>
                <div className="progressBarStyle" style={{width: `${progress.react}%`}}>React {progress.react}%</div>
            </div>
            <div style={bar}>
                <div className="progressBarStyle" style={{width: `${progress.cms}%`}}>Content Managaement Systems {progress.cms}%</div>
            </div>
            <div style={bar}>
                <div className="progressBarStyle" style={{width: `${progress.seo}%`}}>SEO {progress.seo}%</div>
            </div>
            <div style={bar}>
                <div className="progressBarStyle" style={{width: `${progress.udesign}%`}}>UI/UX Design {progress.udesign}%</div>
            </div>
            <div style={bar}>
                <div className="progressBarStyle" style={{width: `${progress.node}%`}}>Node {progress.node}%</div>
            </div>
            <div style={bar}>
                <div className="progressBarStyle" style={{width: `${progress.gdesign}%`}}>Graphic Design {progress.gdesign}%</div>
            </div>

                

            </div>
         </div>



            
        </div>
     



        


           
        </div>
    )
}